import App_pc from './App_pc.jsx';

function App() {
  return <div style={{ fontFamily: 'Poppins', width: '100%', height: '100%', }}><App_pc /></div>
}
export default App;